export default __webpack_public_path__ + "static/media/symbol-north-arrow.718c3de1.svg";